



























































































































































































import { CourierDTO, SearchMetadataDto } from "@/model/data.model";
import { ShipmentService } from "@/services/ShipmentService";
import { getStoreId } from "@/services/AuthService";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { SelectOptionDef } from "@/model/component.model";
import { PriceListService } from "@/services/PriceListService";
import { forEach } from "lodash";

@Component({
  components: {}
})
export default class SearchFilters extends Vue {
  @Prop() metadata: SearchMetadataDto;
  @Prop() searchFilter: any;
  @Prop() filterAvailablePickup: any;
  private couriers: SelectOptionDef[] = [];
  private availablePickup: CourierDTO[] = [];
  private idServices: number[] = [];

  search() {
    this.$emit("search", this.searchFilter);
  }
  searchSelect(search, autocomplete, hasRemoteSearch) {
    if (
      (search === undefined || search === "" || search.length < 3) &&
      hasRemoteSearch
    ) {
      return;
    }
    const searchInput = search.toLowerCase();
    ShipmentService.getAutocompleteData(
      this.processUrl(autocomplete),
      searchInput
    ).then(res => {
      if (this.filterAvailablePickup) {
        // const foundCourier = this.availablePickup.filter(item => {
        //   let isFound = false;
        //   res.forEach(itemRes => {
        //     if (itemRes.courierName === item.courierName) isFound = true;
        //   });
        //   return isFound;
        // });
        this.couriers = (this.availablePickup as CourierDTO[]).map(courier => {
          return {
            value: courier.idMBEBusiness,
            label: courier.courierName
          };
        });
      } else {
        this.couriers = (res as CourierDTO[]).map(courier => {
          return {
            value: courier.idMBEBusiness,
            label: courier.courierName
          };
        });
      }
    });
  }

  processUrl(url) {
    return url.replace("autocomplete:", "").replace("{STORE_ID}", getStoreId());
  }

  hasRemoteSearch(url) {
    const processUrl = this.processUrl(url);
    if (processUrl.indexOf("|") !== -1) {
      return true;
    }
    if (processUrl.indexOf("&hasRemote=true") !== -1) {
      return true;
    }
    return processUrl.indexOf("&dontLoadOnStart=true") !== -1;
  }

  async getServiceIds() {
    return (await ShipmentService.getPickupCouriers()) as any[];
  }

  async mounted() {
    if (this.filterAvailablePickup) {
      const serviceId = await this.getServiceIds();
      const serviceIdList: any[] = [];
      serviceId.forEach(item => serviceIdList.push(item.courierServiceId));
      const result = await PriceListService.couriersByIdService(
        serviceIdList.join(",")
      );
      result.forEach(item => {
        this.availablePickup.push(item);
      });
    }
    this.metadata.filters
      .filter(item => item.typeSpec.includes("autocomplete"))
      .forEach(meta => {
        this.searchSelect("", meta.typeSpec, false);
      });
  }
}
